module.exports = __webpack_public_path__ + "static/media/image_64.d8929247.png";